const pad = (value: number) => String(value).padStart(2, '0');

/** The calendar day of `now` as `YYYY-MM-DD`, the way the day inputs and the backend write a day. */
export const dayOf = (now: Date): string => `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;

/** The local calendar day `day` (`YYYY-MM-DD`) names, at midnight. */
export const dateOf = (day: string): Date => {
    const [year, month, date] = day.split('-').map(Number);

    return new Date(year, month - 1, date);
};

/** The day `months` months before `now`, as `YYYY-MM-DD`; a day the earlier month lacks becomes its last day. */
export const monthsBefore = (now: Date, months: number): string => {
    const lastOfTarget = new Date(now.getFullYear(), now.getMonth() - months + 1, 0);

    return dayOf(
        new Date(lastOfTarget.getFullYear(), lastOfTarget.getMonth(), Math.min(now.getDate(), lastOfTarget.getDate())),
    );
};

/** Whether `day` (`YYYY-MM-DD`) lies after today; rent is only billed for days that have begun. */
export const isInTheFuture = (day: string, now: Date): boolean => day > dayOf(now);
